import { Component, OnInit, Input, NgModule  } from '@angular/core';
import { NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';



@Component({
    selector: 'mat-container',
    template:`<ng-content></ng-content>`,
    styles:[ `:host {display: block;}`],
             
})
export class MatContainer {
}


@Component({
    selector: 'mat-title',
    template: `<ng-content></ng-content>{{title}}`,
    styles: [`:host {display: block;
        font-weight:500;
        font-size:1.2em;
         }`] ,
})
export class MatTitle implements OnInit {
    @Input()
    title:string="";
    constructor() { }

    ngOnInit(): void { }
}

@Component({
    selector: 'mat-label-title',
    template: `<span class="label-title">
                  {{label}}
                  <ng-content class="label-title"></ng-content>
               </span>   
               `,
    styleUrls:[ 'mat-container.scss'],
})
export class TitleComponent implements OnInit {
    fLabel;
    @Input()
    get label():string{
         return this.fLabel;
    };
    set label(x){
        console.log(x);
        this.fLabel = x;
    }
    constructor() { }

    ngOnInit(): void { 
        console.log(this.label) 
    }
}



@Component({
    selector: 'mat-labeled',
    template: `<div fxLayout="column"><div class="label-title">{{label}}</div>
                 <span class="border-bottom" [innerHtml]>
                 <ng-content></ng-content>
                 </span>
               </div>`,
    styleUrls:[ 'mat-container.scss'],
})
export class LabeledComponent implements OnInit {
    fLabel;
    @Input()
    get label():string{
         return this.fLabel;
    };
    set label(x){
        console.log(x);
        this.fLabel = x;
    }
    constructor() { }

    ngOnInit(): void { 
        console.log(this.label) 
    }
}



@Component({
    selector:'mat-content',
    template:`<ng-content></ng-content>`,
    styles:[`:host {display: block;}`]
})
export class MatContent{

}

@Component({
    selector: 'mat-actions',
    template:`<ng-content></ng-content>`,
    styles:[ `:host {display: block;}`],
})
export class MatActions{

}



@NgModule({
    imports:[

    ],
    declarations:[
        MatContainer,
        MatTitle,
        MatContent,
        MatActions,
        LabeledComponent,
        TitleComponent,
    ],
    exports:[
        MatContainer,
        MatTitle,
        MatContent,
        MatActions,
        LabeledComponent,
        TitleComponent,
    ],
    schemas:[ NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  ]
})

export class MatContainerModule {

}

